import { UiCheckIcon } from "@jti/brand-icons/ui-check";
import { useTranslations } from "@jti/ui";

import styles from "./SubscriptionBenefits.module.scss";

const BenefitItem = ({ children }: { children: React.ReactNode }) => (
  <li className={styles.benefitItem}>
    <UiCheckIcon className={styles.checkIcon} />
    {children}
  </li>
);

export const SubscriptionBenefits = () => {
  const { __ } = useTranslations();

  const benefitOne = __("summarySubscription.benefit1");
  const benefitTwo = __("summarySubscription.benefit2");
  const benefitThree = __("summarySubscription.benefit3");
  const benefitFour = __("summarySubscription.benefit4");
  const benefitFive = __("summarySubscription.benefit5");

  const isBenefitsSectionVisible = benefitOne || benefitTwo || benefitThree || benefitFour || benefitFive;

  if (!isBenefitsSectionVisible) return null;

  return (
    <ul className={styles.benefitsList}>
      {!!benefitOne && <BenefitItem>{benefitOne}</BenefitItem>}
      {!!benefitTwo && <BenefitItem>{benefitTwo}</BenefitItem>}
      {!!benefitThree && <BenefitItem>{benefitThree}</BenefitItem>}
      {!!benefitFour && <BenefitItem>{benefitFour}</BenefitItem>}
      {!!benefitFive && <BenefitItem>{benefitFive}</BenefitItem>}
    </ul>
  );
};
